import React from 'react';
import AdminPanel from '../components/AdminPanel';
import Header from '../components/Header';
import PanelTestimonios from '../components/PanelTestimonios';
import PanelServicios from '../components/PanelServicios';
import PanelCursosTalleres from '../components/PanelCursosTalleres';
import PanelEventosTL from '../components/PanelEventosTL';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AdminPage = ({ embeds, onAddEmbed, onDeleteEmbed, onLogout, isLoggedIn }) => { // Agregar isLoggedIn aquí
    const navigate = useNavigate();

    const handleLogout = () => {
        onLogout();
        navigate('/login'); // Redirigir al login después de cerrar sesión
    };

    return (
        <div>
            {/* Pasamos isLoggedIn al Header para mostrar el botón solo si está logeado */}
            <Header isLoggedIn={isLoggedIn} onLogout={onLogout} />
            <AdminPanel embeds={embeds} onAddEmbed={onAddEmbed} onDeleteEmbed={onDeleteEmbed} />
            <PanelTestimonios />
            <PanelServicios />
            <PanelCursosTalleres />
            <PanelEventosTL />
        </div>
    );
};

export default AdminPage;